(() => {
  document.querySelectorAll("[data-magic-moments-page-nav]").forEach((root) => {
    const menuButton = root.querySelector(".store-menu-button");
    const mobileMenu = root.querySelector(".store-mobile-menu");
    if (!menuButton || !mobileMenu) return;

    const setMenuOpen = (isOpen) => {
      mobileMenu.hidden = !isOpen;
      menuButton.setAttribute("aria-expanded", String(isOpen));
    };

    menuButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      setMenuOpen(mobileMenu.hidden);
    });

    mobileMenu.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => setMenuOpen(false));
    });

    document.addEventListener("click", (event) => {
      if (mobileMenu.hidden) return;
      if (mobileMenu.contains(event.target) || menuButton.contains(event.target)) return;
      setMenuOpen(false);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") setMenuOpen(false);
    });
  });
})();
